<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { p1Api } from '@/lib/p1-api';
const router = useRouter();
const currentPassword = ref('');
const newPassword = ref('');
const confirmation = ref('');
const error = ref('');
const loading = ref(false);
async function submit() {
  if (newPassword.value !== confirmation.value) {
    error.value = '两次输入的新密码不一致';
    return;
  }
  loading.value = true;
  error.value = '';
  try {
    await p1Api.changePassword(currentPassword.value, newPassword.value);
    const me = await p1Api.me();
    await router.push(me.permissions.includes('system:operate') ? '/admin' : '/documents');
  } catch (reason) {
    error.value = reason instanceof Error ? reason.message : '密码修改失败';
  } finally {
    loading.value = false;
  }
}
</script>
<template>
  <main class="auth-layout">
    <section class="auth-panel">
      <p class="phase">首次登录安全设置</p>
      <h1>修改初始密码</h1>
      <p class="form-note">完成修改前不能访问业务功能。普通账号密码至少 12 位。</p>
      <form @submit.prevent="submit">
        <label
          >当前密码<input v-model="currentPassword" type="password" required minlength="12"
        /></label>
        <label>新密码<input v-model="newPassword" type="password" required minlength="12" /></label>
        <label
          >确认新密码<input v-model="confirmation" type="password" required minlength="12"
        /></label>
        <p v-if="error" class="form-error" role="alert">{{ error }}</p>
        <button type="submit" :disabled="loading">
          {{ loading ? '正在保存…' : '修改密码并继续' }}
        </button>
      </form>
    </section>
  </main>
</template>
